/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
//import {usePermissions} from '../../../../hook/permissions'
import axios from 'axios'
import {useLayout} from '../../core'
const API_URL = process.env.REACT_APP_API_URL || 'api'

export function AsideMenuMain() {
  const {config} = useLayout()
  const {aside} = config
  const intl = useIntl()
  const [name, setName] = React.useState('Ambipar')

  useEffect(() => {
    getParameters()
  }, [])

  const getParameters = async () => {
    const {data} = await axios.get(API_URL + '/v1/parameters/select2?code=company_name')
    let response = data.results
    setName(response[0].value)
  }

  //permissions Menu
  // const licenças = usePermissions('Licenças')
  // const condicionantes = usePermissions('Condicionantes')
  // const planosAcao = usePermissions('Planos de Ação')
  // const providencias = usePermissions('Gestão de Providências')
  //const projetos = usePermissions('Projetos')
  // const usuarios = usePermissions('Usuários do Sistema')
  // const roles = usePermissions('Perfis do Sistema')
  // const parametros = usePermissions('Parâmetros')

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          {aside.theme === 'dark' && (
            <span className='menu-section  fs-8 ls-1' style={{textShadow: '1px 1px 1px white'}}>
              {name} | SG360
            </span>
          )}
          {aside.theme === 'light' && (
            <span className='menu-section   fs-8 ls-1'>{name} | SG360</span>
          )}
        </div>
      </div>

      {/* inicio MENU SGT  */}
      <AsideMenuItemWithSub
        to='/Cloud'
        title='SGT'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/maps/map002.svg'
      >
        <AsideMenuItem
          to='/owners'
          title={intl.formatMessage({id: 'OWNERS.TITLE'})}
          hasBullet={true}
        />

        <AsideMenuItem
          to='/properties'
          title={intl.formatMessage({id: 'PROPERTIES.TITLE'})}
          hasBullet={true}
        />

        <AsideMenuItem
          to='/contracts'
          title={intl.formatMessage({id: 'CONTRACTS.TITLE'})}
          hasBullet={true}
        />

        <AsideMenuItem
          to='/indemnityitem'
          title={intl.formatMessage({id: 'INDEMNITY_ITEM.TITLE'})}
          hasBullet={true}
        />
        <AsideMenuItem
          to='/evaluationreports'
          title={intl.formatMessage({id: 'EVALUATION_REPORT.TITLE'})}
          hasBullet={true}
        />
      </AsideMenuItemWithSub>
      {/* fim MENU SGT  */}

      {/* inicio dos cadastros  */}
      <AsideMenuItemWithSub
        to='/provider99'
        title={intl.formatMessage({id: 'MENU.REGISTERS'})}
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/files/fil013.svg'
      >

        {/* )} */}
          <AsideMenuItem
              to='/projects'
              title={intl.formatMessage({id: 'PROJECT.PROJECT_PLURAL'})}
              hasBullet={true}
          />

        <AsideMenuItem
          to='/enterprises_type'
          title={intl.formatMessage({id: 'ENTERPRISE_TYPE.ENTERPRISE_TYPE_PLURAL'})}
          //title='Tipos de Empreendimentos'
          hasBullet={true}
        />
        <AsideMenuItem
          to='/enterprises'
          title={intl.formatMessage({id: 'ENTERPRISE.ENTERPRISE_PLURAL'})}
          hasBullet={true}
        />
        <AsideMenuItem
          to='/fields'
          title={intl.formatMessage({id: 'FIELD.FIELD_PLURAL'})}
          hasBullet={true}
        />
          <AsideMenuItem
              to='/entrepreneurs'
              title={intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_PLURAL'})}
              hasBullet={true}
          />
        {/* <AsideMenuItem
          to='/products'
          // title={intl.formatMessage({id: 'PRODUCTS.TITLE'})}
          title='Produtos'
          hasBullet={true}
        /> */}
        {/* <AsideMenuItem
          to='/costcenters'
          // title={intl.formatMessage({id: 'PRODUCTS.TITLE'})}
          title='Centro de Custo'
          hasBullet={true}
        /> */}
        <AsideMenuItem
          to='/issueorgans'
          title={intl.formatMessage({id: 'ISSUE_ORGANS.TITLE'})}
          hasBullet={true}
        />
        <AsideMenuItem
          to='/measurement_units'
          title={intl.formatMessage({id: 'MEASUREMENT.TITLE'})}
          // title='Unidades de Medida'
          hasBullet={true}
        />

        {/* permissao de projeto */}
        {/* {projetos.show && ( */}

          <AsideMenuItem
              to='/providers'
              title={intl.formatMessage({id: 'PROVIDER.TITLE'})}
              hasBullet={true}
          />
        {/* )} */}

        {/* <AsideMenuItem
          to='/releases'
          title={intl.formatMessage({id: 'MENU.RELEASES'})}
          hasBullet={true}
        /> */}
      </AsideMenuItemWithSub>
      {/* fim dos cadastros  */}

      {/* inicio MENU ADMINISTRADOR  */}
      <AsideMenuItemWithSub
        to='/Cloud'
        title={intl.formatMessage({id: 'MENU.ADMINISTRATOR'})}
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/coding/cod001.svg'
      >
          {/* permissao de usuarios */}
          {/* {usuarios.show && ( */}
          <AsideMenuItem
              to='/users'
              title={intl.formatMessage({id: 'USERS.TITLE'})}
              hasBullet={true}
          />
        {/* permissao de perfil de usuarios */}
        {/* {roles.show && ( */}
        <AsideMenuItem
          to='/roles'
          title={intl.formatMessage({id: 'ROLES.TITLE'})}
          hasBullet={true}
        />
        {/* )} */}

        {/* permissao de parametros */}
        {/* {parametros.show && ( */}
        <AsideMenuItem
          to='/parameters'
          title={intl.formatMessage({id: 'MENU.PARAMETERS'})}
          hasBullet={true}
        />
        {/* )} */}

        {/* permissao de aplicações */}
        {/* {applications.show && ( */}
        <AsideMenuItem
          to='/applications'
          title={intl.formatMessage({id: 'APPLICATIONS.TITLE'})}
          hasBullet={true}
        />
        {/* )} */}
      </AsideMenuItemWithSub>
      {/* fim MENU ADMINISTRADOR  */}

      {/* inicio MENU SGA  */}
      <AsideMenuItemWithSub
        to='/Cloud'
        title='SGA'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/abstract/abs047.svg'
      >
        <AsideMenuItem
          to='/sga'
          title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          hasBullet={true}
        />
        {/* permissao de licença */}
        {/* {licenças.show && ( */}
        <AsideMenuItem
          to='/licenses'
          title={intl.formatMessage({id: 'MENU.LICENSE'})}
          hasBullet={true}
        />
        {/* )} */}

        {/* permissao de condicionantes */}
        {/* {condicionantes.show && ( */}
        <AsideMenuItem
          to='/conditioning'
          title={intl.formatMessage({id: 'MENU.CONDITIONING'})}
          hasBullet={true}
        />
        {/* )} */}

        {/* permissao de plano de ação */}
        {/* {planosAcao.show && ( */}
        <AsideMenuItem
          to='/actionplans'
          title={intl.formatMessage({id: 'MENU.ACTIONPLAN'})}
          hasBullet={true}
        />
        {/* )} */}

        {/* permissao de providencias */}
        {/* {providencias.show && (
          <AsideMenuItem
            to='/providences'
            title={intl.formatMessage({id: 'MENU.PROVIDENCE'})}
            hasBullet={true}
          />
        )} */}

        {/* permissao de projetos */}
        <AsideMenuItem
          to='/license_types'
          title={intl.formatMessage({id: 'LICENSE_TYPES.TITLE'})}
          hasBullet={true}
        />
        {/* <AsideMenuItem
          to='/cloudfile999'
          title={intl.formatMessage({id: 'MENU.LICENSECOST'})}
          hasBullet={true}
        /> */}
      </AsideMenuItemWithSub>
      {/* fim MENU SGA  */}

      <AsideMenuItem
        to='/applicationsview'
        title={intl.formatMessage({id: 'APPLICATIONS.TITLE'})}
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/general/gen017.svg'
      />

      {/* inicio dos auxiliares  */}
      {/* <AsideMenuItemWithSub
        to='/Cloud'
        title='Cloud'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/files/fil022.svg'
      >
        <AsideMenuItem to='/cloudfile' title='Cloud - File' hasBullet={true} />
        <AsideMenuItem to='/cloudcategory' title='Cloud - Category' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/apps/chat'
        title='History'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        <AsideMenuItem to='/historylogs' title='Logs' hasBullet={true} />
      </AsideMenuItemWithSub> */}

      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}
